import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { LoanLimitViewRegionsQueryResponse, LoanLimitViewRegions400, LoanLimitViewRegions401, LoanLimitViewRegions403, LoanLimitViewRegions404, LoanLimitViewRegions410, LoanLimitViewRegions422, LoanLimitViewRegions429, LoanLimitViewRegions500 } from "../types/LoanLimitViewRegions";

export const loanLimitViewRegionsQueryKey = () =>     [{url:`/api/credit-flow-backend/v1/loan_limit/view_regions`}] as const;
      export function loanLimitViewRegionsQueryOptions <TData = LoanLimitViewRegionsQueryResponse, TError = LoanLimitViewRegions400 | LoanLimitViewRegions401 | LoanLimitViewRegions403 | LoanLimitViewRegions404 | LoanLimitViewRegions410 | LoanLimitViewRegions422 | LoanLimitViewRegions429 | LoanLimitViewRegions500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = loanLimitViewRegionsQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/credit-flow-backend/v1/loan_limit/view_regions`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/credit-flow-backend/v1/loan_limit/view_regions
 */

export function useLoanLimitViewRegions <TData = LoanLimitViewRegionsQueryResponse, TError = LoanLimitViewRegions400 | LoanLimitViewRegions401 | LoanLimitViewRegions403 | LoanLimitViewRegions404 | LoanLimitViewRegions410 | LoanLimitViewRegions422 | LoanLimitViewRegions429 | LoanLimitViewRegions500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? loanLimitViewRegionsQueryKey();

  const query = useQuery<TData, TError>({
    ...loanLimitViewRegionsQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
